import { Helmet } from 'react-helmet-async'
import { useFranchiseData } from '../hooks/useFranchiseData'

export default function SeoDefaults() {
  const { franchiseData } = useFranchiseData()
  const origin = typeof window !== 'undefined' ? window.location.origin : ''

  const organization = franchiseData?.name || 'Travel Agency'
  const telephone = franchiseData?.telephone || ''
  const email = franchiseData?.email || ''
  const logo = franchiseData?.general_logo_url || franchiseData?.logo_url || ''
  const description = franchiseData?.catch_phrase
    ? `${organization} - ${franchiseData.catch_phrase}`
    : `${organization} - Travel & Holiday Packages`
  const themeColor = franchiseData?.button_color || franchiseData?.topbar_color || '#3b82f6'
  const sameAs = [
    franchiseData?.facebook,
    franchiseData?.instagram,
    franchiseData?.linkedin,
  ].filter(Boolean) as string[]

  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: organization,
    url: origin ? `${origin}/` : '/',
    potentialAction: {
      '@type': 'SearchAction',
      target: origin ? `${origin}/packages?search={search_term_string}` : '/packages?search={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  }

  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: organization,
    url: origin ? `${origin}/` : '/',
    logo,
    email,
    telephone,
    address: franchiseData?.address,
    sameAs,
  }

  return (
    <Helmet>
      {/* Dynamic title & meta from franchise data */}
      <title>{`${organization} - Travel & Holiday Packages`}</title>
      <meta name="description" content={description} />
      <meta name="theme-color" content={themeColor} />
      <link rel="canonical" href={origin ? `${origin}/` : '/'} />

      {/* Favicon from franchise logo */}
      {logo && <link rel="icon" type="image/png" href={logo} />}

      {/* Open Graph */}
      <meta property="og:site_name" content={organization} />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={`${organization} - Travel & Holiday Packages`} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={origin ? `${origin}/` : '/'} />
      {logo && <meta property="og:image" content={logo} />}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={`${organization} - Travel & Holiday Packages`} />
      <meta name="twitter:description" content={description} />
      {logo && <meta name="twitter:image" content={logo} />}

      {/* JSON-LD */}
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(orgJsonLd)}</script>
    </Helmet>
  )
}
